import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/recursos_humanos/bajaIgss';
import Baja from './Baja';


const ms2p = (state) => {
  return {
    ...state.baja_igss_rh,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Baja);
